import { createContext, useContext } from "react";

export interface PreferenceState {
  antiSpoiler: boolean;
  setAntiSpoiler: (value: boolean) => void;
}

export const PreferencesContext = createContext<PreferenceState | undefined>(undefined);

export function usePreferences() {
  const value = useContext(PreferencesContext);
  if (!value) throw new Error("PreferencesProvider is missing");
  return value;
}
